import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles((theme: any) => ({
  // Sites page
  addSiteButton: {
    marginRight: 12
  },

  // Dialog frame, shared by the setup and result dialogs
  dialogPaper: {
    minHeight: "80vh",
    maxHeight: "90vh"
  },
  dialogTitle: {
    height: 60,
    padding: "0 16px 0 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0
  },
  dialogContent: {
    overflowY: "auto",
    borderBottom: "none"
  },
  actionButton: {
    minWidth: 120
  },

  // Setup dialog
  errorAlert: {
    marginBottom: 16
  },
  mainSectionTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: "#421a40"
  },
  customerAdminUserRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    columnGap: 16,
    minHeight: 40
  },
  packageCheckboxLabel: {
    marginLeft: 0
  },
  sectionDivider: {
    margin: "8px 0 16px"
  },

  // Fields
  field: {
    marginBottom: 2
  },
  helperText: {
    marginTop: 0,
    lineHeight: 1.5
  },
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    marginTop: 16,
    marginBottom: 12
  },
  // Billing sits lower so its rows line up with the Details column beside it
  sectionTitleSpaced: {
    marginTop: 33
  },
  sectionTitleText: {
    textTransform: "uppercase"
  },
  sectionTitleAction: {
    marginLeft: "auto"
  },
  labelWithHint: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6
  },
  enforceSwitchLabel: {
    margin: 0,
    gap: 8
  },
  columns: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      gap: 24
    }
  },
  column: {
    flex: 1,
    minWidth: 0
  },
  columnDivider: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block"
    }
  },

  // Package trees
  treeItem: {
    "--tree-view-color": "#545964",
    "--tree-view-bg-color": "#fff"
  },
  packageCheckedIcon: {
    width: 16,
    height: 16
  },
  packageContent: {
    padding: "16px 0 0 28px"
  }
}));

export default useStyles;
